import styled from 'styled-components';
import { PExtraSmall, PSmall } from '../elements/Text';
import { Input } from '../elements/Input';

export const FormLabel = styled(PSmall)`
  margin-bottom: 0;
`;

export const FormInfo = styled(PExtraSmall)`
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 0;
`;

export const FormInput = styled(Input)`
  margin-top: 8px;
`;
